import GetStartedView from "../views/GetStartedView";
import { Dialog, DialogContent } from "../components/ui/dialog";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../store/store";
import { setIsGetStartedDialogOpen, setShopName } from "../store/flowSlice";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "wasp/client/auth";
import { updateCurrentUser } from "wasp/client/operations";
import { useTranslation } from "../i18n/hooks";

type GetStartedDialogProps = {};

const GetStartedDialog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: user } = useAuth();
  const { t } = useTranslation();
  const { isGetStartedDialogOpen } = useSelector(
    (state: RootState) => state.flow
  );
  const {currentCollection} = useSelector((state: RootState) => state.user);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const paramValue = searchParams.get("shop");
    const app = searchParams.get("app");
    searchParams.delete("shop");
    searchParams.delete("app");

    if (app == 'miq' && paramValue && user && !currentCollection?.collection?.miqHasCompletedShopifyImport) {
      dispatch(setShopName(paramValue));
      dispatch(setIsGetStartedDialogOpen(true));
      searchParams.delete("shop");
      navigate(
        {
          pathname: location.pathname,
          search: searchParams.toString(),
        },
        { replace: true }
      );
    }
    if(app == "gengage" && paramValue) {
      updateCurrentUser({ gengageShopifyDomain: paramValue });
      navigate(
        {
          pathname: location.pathname,
          search: searchParams.toString(),
        },
        { replace: true }
      );
    }
  }, [location.search, navigate, user]);

  if (!user) return null;

  return (
    <Dialog
      open={isGetStartedDialogOpen}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          setShopName(null);
        }
        dispatch(setIsGetStartedDialogOpen(isOpen));
      }}
    >
      <DialogContent>
        <GetStartedView initialStep={0} />
      </DialogContent>
    </Dialog>
  );
};

export default GetStartedDialog;
